module.exports = __webpack_public_path__ + "static/media/optomotrist.a73c6768.jpg";